import { ChangeEvent, FC } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { IFixedTermSimulation } from '../types/IFixedTermSimulation';
import { Input } from '@bpba/form-components';
import { DECIMAL_NUMBER_FORMAT, INTEGER_NUMBER_FORMAT } from '../constants/form';
import { NumberFormat } from '../functions/NumberFormat';
import { PiCurrencyDollar } from 'react-icons/pi';

type Props = {
  form: UseFormReturn<IFixedTermSimulation, any, IFixedTermSimulation>;
  readOnly?: boolean | undefined;
};

export const InputAmount: FC<Props> = ({ form, readOnly }) => {
  const onChangeAmount = (event: ChangeEvent<HTMLInputElement> | string) => {
    if (typeof event == 'string') return;

    const input: string = event.currentTarget.value;

    /* Se actualiza la parte visual si tiene el formato esperado */
    if (DECIMAL_NUMBER_FORMAT.test(NumberFormat.cleanNumberFormat(input))) {
      const inputFormatted = NumberFormat.formatNumber(input);

      event.currentTarget.value = inputFormatted;
    }

    /* Se actualiza estado formulario */
    const inputParsed = NumberFormat.parseFormattedNumber(input);

    form.setValue('amount', inputParsed);
  };

  const filterNumbers = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (!event) return;

    const key = event.key;

    if (key !== ',' && key !== 'Backspace' && key !== 'Delete' && key !== 'Tab' && key !== 'ArrowRight' && key !== 'ArrowLeft' && !INTEGER_NUMBER_FORMAT.test(key))
      event.preventDefault();
  };

  return (
    <Input
      name="amount"
      type="text"
      control={form.control}
      leftIcon={PiCurrencyDollar}
      label="Ingrese monto (ARS)"
      placeholder="Monto (ej: $1.000)"
      onChange={onChangeAmount}
      onKeyDown={filterNumbers}
      readOnly={readOnly}
    />
  );
};
